import styled from '@emotion/styled';
import { BillingCycle } from '../data/interfaces/pricing-types';

const StyledToggleContainer = styled.div`
  background: #333;
  display: flex;
  gap: 2px;
  align-items: center;
  padding: 2px;
  border-radius: 4px;
`;

const StyledToggleOption = styled.button<{ selected: boolean }>`
  display: flex;
  gap: 4px;
  height: 28px;
  align-items: center;
  justify-content: center;
  padding: 2px 12px;
  border: none;
  border-radius: 4px;
  font-family: 'Centra No1';
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
  white-space: nowrap;
  background: ${props => props.selected ? 'white' : 'transparent'};
  color: ${props => props.selected ? '#333' : 'white'};
  transition: all 0.2s ease;

  &:hover {
    opacity: 0.8;
  }
`;

interface BillingToggleProps {
  selected: BillingCycle;
  onChange: (cycle: BillingCycle) => void;
}

export const BillingToggle = ({ selected, onChange }: BillingToggleProps) => {
  return (
    <StyledToggleContainer>
      <StyledToggleOption
        selected={selected === BillingCycle.MONTHLY}
        onClick={() => onChange(BillingCycle.MONTHLY)}
      >
        Monthly
      </StyledToggleOption>
      <StyledToggleOption
        selected={selected === BillingCycle.ANNUAL}
        onClick={() => onChange(BillingCycle.ANNUAL)}
      >
        Annual
      </StyledToggleOption>
    </StyledToggleContainer>
  );
};
